import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { Link, useHistory } from "react-router-dom";
import './spidSearchModal.scss';

export default function SpidSearchModal ({ 
    search, setSearch, isOpen, setIsopen, prefix, title, returnUrl, linkTitle, linkTo
}) {
    const [searchIsLoading, setSearchIsLoading] = useState(false)
    const history = useHistory();

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={() => setIsopen(false)}
            className="card bulk-allocate spid-search-modal"
            contentLabel="SPID Search"
            style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}
        >
            <div className='spid-search-modal-container'>
                <h3>Search for a Core SPID</h3>
                <p>Please enter the Core SPID you wish to search for.</p>
                <div className='spid-search-input-container'>
                    <input onChange={e => setSearch(e.target.value)} value={ search ?? '' } 
                        onKeyDown={(event) => {
                            if (event.code === "Enter") {
                                setSearchIsLoading(true)
                                history.push({
                                    pathname: linkTo,
                                    state: {
                                        spid: search,
                                        prefix,
                                        title,
                                        returnUrl,
                                        linkTitle
                                    }
                                })
                            }
                        }}
                    />
                    <button className="button compact smaller-text cancel colour-white" onClick={() => setIsopen(false)} >Cancel</button>
                    <Link 
                        to={{ pathname: linkTo, state: { spid: search, prefix: prefix, title: title, returnUrl: returnUrl, linkTitle: linkTitle } }}
                        className="button compact smaller-text background-primary colour-white"
                        style={{ textDecoration: 'none' }}
                        disabled={!search || searchIsLoading}
                        onClick={() => setSearchIsLoading(true)}
                    >
                        {
                            searchIsLoading ?
                                <div style={{ padding: '0em 1em' }} >
                                    <i className="fa fa-spinner fa-spin"></i>
                                </div>
                            :
                                "Search"
                        }
                    </Link>
                </div>
            </div>
        </ReactModal>
    )
}